import { API_ENDPOINT } from "@iso/config/index";
import { axiosClient } from "@iso/helpers/axios.config";

const ADD_ON_ENDPONT = `${API_ENDPOINT}/addon`;
const ADD_ON_ITEM_ENDPONT = `${API_ENDPOINT}/addon-item`;

const addOnManagerApi = {
   getFilterProperties: () => {
      return axiosClient.get(`${ADD_ON_ENDPONT}/filter-properties`);
   },

   getOptionsProperty: (params) => {
      return axiosClient.get(`${ADD_ON_ENDPONT}/options-property`, {
         params,
      });
   },

   gets: (params) => {
      return axiosClient.get(ADD_ON_ENDPONT, { params });
   },

   get: (id) => {
      return axiosClient.get(`${ADD_ON_ENDPONT}/${id}`);
   },

   post: (body) => {
      return axiosClient.post(ADD_ON_ENDPONT, body);
   },

   put: (id, body) => {
      return axiosClient.put(`${ADD_ON_ENDPONT}/${id}`, body);
   },

   delete: (id) => {
      return axiosClient.delete(`${ADD_ON_ENDPONT}/${id}`);
   },

   //Add-On Item
   getsAllAddOnItem: (params) => {
      return axiosClient.get(`${ADD_ON_ITEM_ENDPONT}/all`, { params });
   },

   getsAddOnItem: (params) => {
      return axiosClient.get(ADD_ON_ITEM_ENDPONT, { params });
   },

   postAddOnItem: (body) => {
      return axiosClient.post(ADD_ON_ITEM_ENDPONT, body);
   },

   postSortingAddOnItem: (body) => {
      return axiosClient.post(`${ADD_ON_ITEM_ENDPONT}/update-sorting`, body);
   },

   putAddOnItem: (id, body) => {
      return axiosClient.put(`${ADD_ON_ITEM_ENDPONT}/${id}`, body);
   },

   deleteAddOnItem: (id) => {
      return axiosClient.delete(`${ADD_ON_ITEM_ENDPONT}/${id}`);
   },
};

export default addOnManagerApi;
